let lockCount = 0;

export const lockScroll = () => {
  lockCount++;
  alert(lockCount);
  if (typeof document !== "undefined") {
    document.body.style.overflow = "hidden";
  }
};

export const unlockScroll = () => {
  lockCount--;
  if (lockCount <= 0) {
    lockCount = 0;
    if (typeof document !== "undefined") {
      document.body.style.overflow = "unset";
    }
  }
};
